import { DataSource } from "src/models/dataSource";
import { createEntityModel } from "src/store/models/entity/_shared";

export const DataSourceEntityModel = createEntityModel<DataSource>();
